import React from 'react';
import PropTypes from 'prop-types';

import {
  CheckboxInput,
  FormInline,
} from '../../../fragments/forms';

import style from './style.css';


export default class Publish extends React.Component {

  static propTypes = {
    reference: PropTypes.object.isRequired,
    readOnly: PropTypes.bool.isRequired,
    showError: PropTypes.bool.isRequired,
    onUpdate: PropTypes.func.isRequired,
  };

  handleUpdate(published) {
    const {reference} = this.props;
    reference.published = published;

    const {onUpdate} = this.props;
    onUpdate(reference);
  }

  render() {
    const {reference, readOnly} = this.props;

    return (
      <FormInline dom="span" className={style.published}>
        <CheckboxInput
         name="published"
         disabled={readOnly}
         checked={reference.published}
         onChange={this.handleUpdate.bind(this)}>
          Make this study public
        </CheckboxInput>
      </FormInline>
    );
  }
}



// WEBPACK FOOTER //
// ./src/views/wizard/reference/reference-edit/publish.js